import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 448.8 448.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 448.8 448.8\" id=\"icon-check\"><g><g>\r\n\t<g id=\"icon-check_check\">\r\n\t\t<polygon points=\"142.8,323.85 35.7,216.75 0,252.45 142.8,395.25 448.8,89.25 413.1,53.55   \" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" />\r\n\t</g>\r\n</g></g> </symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/check.svg
// module id = 7ZS0
// module chunks = 10